export { default } from './equipment-change-button';